// extracted by mini-css-extract-plugin
export var bodyRow = "_g3-d";
export var cardColumns = "_g3-e";
export var ellipsesOverflow = "_g3-2";
export var flatBottomCorners = "_g3-3";
export var flatTopCorners = "_g3-4";
export var headerActionsDropdown = "_g3-f";
export var headerBottomRow = "_g3-c";
export var headerTopRow = "_g3-b";
export var orderDetailsWrapper = "_g3-0";
export var orderInfoContainer = "_g3-1";
export var productDetails = "_g3-9";
export var productImage = "_g3-5";
export var responsiveTable = "_g3-8";
export var shipmentContainer = "_g3-a";
export var tableBottomLeft = "_g3-6";
export var tableBottomRight = "_g3-7";